module.exports = __webpack_public_path__ + "static/media/product_list_5.66f830f3.png";